import { FC, useId } from 'react'
import cx from 'classnames'

import * as SC from './styled'

export type TabsProps = MinimalSeoBlock & {
  className?: string
  title?: string
  tabs: {
    title: string
    content: React.ReactNode
  }[]
}

const Tabs: FC<TabsProps> = ({
  className,
  title,
  tabs,
  htmlTag,
  htmlTitleTag,
}) => {
  const id = useId()
  return (
    <SC.Container className={cx('Tabs', className)} as={htmlTag}>
      <SC.Title as={htmlTitleTag}>{title}</SC.Title>
      <SC._Tabs>
        <SC.Scroller>
          <SC._TabList aria-label={title}>
            {tabs.map((tab, index) => (
              <SC._Tab key={index} id={`${id}--${index}`}>
                {tab.title}
              </SC._Tab>
            ))}
          </SC._TabList>
        </SC.Scroller>
        {tabs.map((tab, index) => (
          // if needs animatings, set shouldForceMount to true
          <SC._TabPanel
            key={index}
            id={`${id}--${index}`}
            shouldForceMount={false}
          >
            {tab.content}
          </SC._TabPanel>
        ))}
      </SC._Tabs>
    </SC.Container>
  )
}

export default Tabs
